import { axios } from '@/services/axios';

const getCountries = async () => {
    const res = await axios.get('/countries');
    return res.data;
};

export default getCountries;
